import Component from '../abstracts/Component';
import ajaxAction from '../utils/ajaxUtil';
import FiltersComponent from './FiltersComponent';
import InfiniteScrollLogic from '../logics/InfiniteScrollLogic';
import TrackingComponent from '../components/TrackingComponent';
import {replacePageInHistory} from '../utils/BrowserHistoryUtils';

export default class PaginationComponent extends Component {
  get SELECTORS() {
    return {
      paginationLink: '[data-page-link]',
      pagination: '[data-pagination]',
      paginationEl: '[data-current-url]',
      infiniteScrollStartBtn: '.c-l__cta_btn',
      productCard: '.c-product-card',
      productsContainer: '[data-products-container]'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.compEl = compEl;
    this.pagination = this.$component.querySelector(this.SELECTORS.pagination);
    this.paginationEl = this.$component;
    this.paginationLink = this.$component.querySelectorAll(this.SELECTORS.paginationLink);
    this.infiniteScrollStartBtn = this.$component.querySelector(this.SELECTORS.infiniteScrollStartBtn);
    // ajax
    this.ajaxAction = new ajaxAction();
    this.filterComponent = new FiltersComponent(this.compEl);
    this.trackingComponent = new TrackingComponent();
  }

  // main function
  paginationHandling(links) {
    // links loop
    links.forEach(link => {
      // adding listener
      link.addEventListener('click', () => {
        // on click i search the desktop id
        let pageNum = link.getAttribute('data-page-link');
        if(!link.classList.contains('disabled') && !link.classList.contains('selected')) {
          this.filterComponent.filterQuery(pageNum);
        }
      });
    });
  }

  checkPager(response) {
    // check
    if(this.pagination != null) {
      // get the updated pager
      let updatedPaginationEl = response.querySelector(this.SELECTORS.paginationEl);
      // if there are pages, let's update in the response
      if(updatedPaginationEl != null && updatedPaginationEl.querySelectorAll('a').length > 2) {
        // update the html pager
        this.paginationEl.innerHTML = updatedPaginationEl.innerHTML;
        // bind new pager to pagination handling function
        this.paginationHandling(document.querySelectorAll(this.SELECTORS.paginationLink));
        this.paginationEl.classList.remove('hidden');
      } else {
        this.paginationEl.classList.add('hidden');
      }
    }
    // listing part
    if(this.infiniteScrollStartBtn != null) {
      let updatedCards = document.querySelectorAll(this.SELECTORS.productCard);
      let pageSize = response.querySelector('.js-filters-result').getAttribute('data-page-size');
      if(updatedCards.length < pageSize) {
        this.$component.classList.add('hidden');
      } else {
        this.$component.classList.remove('hidden');
      }
    }
  }

  // adding page
  infiniteAddPage(page) {
    let that = this;
    // build query with page
    let query = this.filterComponent.buildQuery(page);
    // call new page
    this.ajaxAction.getPage(query).then(newPage => {
      let newURL = query.replace('isRefineSearch=true', 'isRefineSearch=false');
      replacePageInHistory(newURL.replace(/\s.*/, ''), {}, '', true);
      // parse response
      let response = new DOMParser().parseFromString(newPage, 'text/html');
      // get prods
      let newProductsContainer = response.querySelector('[data-ajax-source="products"]');
      let newProducts = newProductsContainer.querySelectorAll('.c-product-card');
      let newProductsLength = newProductsContainer.querySelectorAll('.c-product-card').length;
      // append found products inside the page
      if(newProducts != null) {
        newProducts.forEach(product => {
          document.querySelector(this.SELECTORS.productsContainer).appendChild(product);
          //enable slick in infinite scroll
          let carouselWrapper = product.querySelector('[data-product-card]');
          that.$emit(that.$customEvents.LISTING_CAROUSEL_EVENTS.show, {payload:carouselWrapper});
        });
        this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.loaded, {newProducts: newProducts});
        this.trackingComponent.actions.loadMore(newProducts);
      }
      this.log(newProductsLength);
      // button
      let newButton = response.querySelector(this.SELECTORS.infiniteScrollStartBtn);
      let actualButton = document.querySelector(this.SELECTORS.infiniteScrollStartBtn);
      if(newButton != null && actualButton != null) {
        actualButton.dataset.page = newButton.getAttribute('data-page');
        actualButton.dataset.infiniteScrollLastpage = newButton.getAttribute('data-infinite-scroll-lastpage');
      }
    });
  }

  // MAIN EVENTS
  bindEvents() {
    // pager update
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      console.log('FILTER UPDATED');
      // check pager
      this.checkPager(payload.response);
    });
    // view more button
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.next, ({payload}) => {
      this.infiniteAddPage(payload.page);
    });
  }

  // MAIN RENDER
  render() {
    this.log('Rendering...');
    // main events
    this.bindEvents();
    if(this.pagination != null) {
      this.paginationHandling(this.paginationLink);
    }
    if(document.querySelector('[data-infinite-scroll]')) {
      this.InfiniteScrollLogic = new InfiniteScrollLogic(this);
      this.InfiniteScrollLogic.render();
    }
  }
}
